// Production Firebase boundary. Demo mode is explicit: VITE_USE_FIREBASE=false.
// In production, configuration errors throw; the app must never silently expose
// mock data when an operator believes they are using the real database.

const env = (typeof import.meta !== 'undefined' && (import.meta as any).env) || {};
const USE_FB = env.VITE_USE_FIREBASE === 'true' || env.VITE_USE_FIREBASE === true;

let _fb: null | { app: unknown; auth: unknown; db: unknown; storage: unknown; googleProvider: unknown } = null;
let _error: Error | null = null;

export async function getFirebase() {
  if (!USE_FB) return null;
  if (_error) throw _error;
  if (_fb) return _fb;
  try {
    const { initializeApp } = await import('firebase/app');
    const { getAuth, GoogleAuthProvider } = await import('firebase/auth');
    const { getFirestore } = await import('firebase/firestore');
    const { getStorage } = await import('firebase/storage');
    const cfg = {
      apiKey: env.VITE_FB_API_KEY,
      authDomain: env.VITE_FB_AUTH_DOMAIN,
      projectId: env.VITE_FB_PROJECT_ID,
      appId: env.VITE_FB_APP_ID,
      storageBucket: env.VITE_FB_STORAGE_BUCKET || `${env.VITE_FB_PROJECT_ID}.firebasestorage.app`,
      messagingSenderId: env.VITE_FB_MESSAGING_SENDER_ID,
    };
    if (!cfg.apiKey || !cfg.authDomain || !cfg.projectId || !cfg.appId) {
      throw new Error('Firebase is enabled but required VITE_FB_* configuration is missing.');
    }
    const app = initializeApp(cfg);
    const googleProvider = new GoogleAuthProvider();
    // Firebase v9+ API: setCustomParameters (singular) — the old setDefaultParameters
    // doesn't exist on GoogleAuthProvider and throws TypeError when called.
    googleProvider.setCustomParameters({ prompt: 'select_account' });
    _fb = { app, auth: getAuth(app), db: getFirestore(app), storage: getStorage(app), googleProvider };
    return _fb;
  } catch (e) {
    _error = e instanceof Error ? e : new Error(String(e));
    console.error('[Clientale] Firebase initialization failed:', _error);
    throw _error;
  }
}

export const FIREBASE_ENABLED = USE_FB;
